var _circle, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEssentials(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 44,
    fill: "#F7FCFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_502_45)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 38,
    fill: "#4DBD94"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_502_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1839 28.9373C52.8987 27.3876 55.1013 27.3876 55.8161 28.9373L61.7131 41.7219C62.0044 42.3535 62.603 42.7884 63.2937 42.8703L77.2748 44.528C78.9696 44.7289 79.6502 46.8237 78.3972 47.9824L68.0606 57.5414C67.55 58.0137 67.3213 58.7173 67.4569 59.3996L70.2007 73.2086C70.5333 74.8826 68.7514 76.1772 67.2622 75.3436L54.9769 68.4668C54.3699 68.1271 53.6301 68.1271 53.0231 68.4668L40.7378 75.3436C39.2486 76.1772 37.4667 74.8826 37.7993 73.2086L40.5431 59.3996C40.6787 58.7173 40.45 58.0137 39.9394 57.5414L29.6028 47.9824C28.3498 46.8237 29.0304 44.7289 30.7252 44.528L44.7063 42.8703C45.397 42.7884 45.9956 42.3535 46.2869 41.7219L52.1839 28.9373Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0918 29.3564C53.4492 28.5816 54.5508 28.5816 54.9082 29.3564L60.8047 42.1406C61.2417 43.088 62.1398 43.7404 63.1758 43.8633L77.1572 45.5215C78.0043 45.6221 78.3447 46.6687 77.7188 47.248L67.3818 56.8076C66.6159 57.516 66.2723 58.5714 66.4756 59.5947L69.2197 73.4033C69.386 74.2402 68.4956 74.8874 67.751 74.4707L55.4648 67.5938C54.5547 67.0846 53.4453 67.0846 52.5352 67.5938L40.249 74.4707C39.5044 74.8874 38.614 74.2402 38.7803 73.4033L41.5244 59.5947C41.7277 58.5714 41.3841 57.516 40.6182 56.8076L30.2812 47.248C29.6553 46.6687 29.9957 45.6221 30.8428 45.5215L44.8242 43.8633C45.8602 43.7404 46.7583 43.088 47.1953 42.1406L53.0918 29.3564Z",
    stroke: "url(#paint0_linear_502_45)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_502_45",
    x: 16,
    y: 16,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_45"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_502_45",
    x: 28.9583,
    y: 27.775,
    width: 50.0835,
    height: 51.8285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_45"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_45",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_45",
    x1: 83,
    y1: 83,
    x2: 30.1335,
    y2: 20.6475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DBD94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FFEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentials);
export default __webpack_public_path__ + "static/media/essentials.b8755f8b44121da8f98b8424b8927e55.svg";
export { ForwardRef as ReactComponent };